<template>
    <section class="container pb-4">
        <div class="flex flex-1 flex-wrap mb-8 md:mb-56">


            <div class="flex-1 text-left md:order-2">
                <h2 class="font-serif text-white text-2xl lg:text-4xl mb-2">Marker</h2>
                <p class="font-sans text-white text-sm md:text-md">78 York Street London<br>W1H 1DP</p>
            </div>

            <div class="text-right flex flex-col justify-between items-end md:order-2">
                <div>
                    <h2 class="font-serif text-white text-2xl lg:text-4xl mb-2">Contact</h2>
                    <p class="font-sans text-white text-sm md:text-md">+44 345 077 3202</p>
                    <p class="font-sans text-white text-sm md:text-md">info@marker.com</p>
                </div>


                <!-- social media icons -->
                <div class="flex flex-row justify-end gap-4 mt-5 md:mt-auto">
                    <a href="https://www.linkedin.com/company/marker-platform/about/" target="_blank"><img src="../../assets/icons/linkedin-icon.svg"></a>
                </div>
                
            </div>


            <div class="mt-4 w-full flex md:flex-1 flex-col md:gap-8 font-serif text-white text-2xl lg:text-4xl text-left md:order-1">
                <router-link to="/" class="router-link border-solid border-b border-green-100 md:border-0 py-3 mb-2 md:mb-0 md:py-0">Home</router-link>
                <a href="https://www.marker-ai.com/about" class="router-link border-solid border-b border-green-100 md:border-0 py-3 mb-2 md:mb-0 md:py-0">About Us</a>
                <a href="https://www.marker-ai.com/the-platform" class="router-link border-solid border-b border-green-100 md:border-0 py-3 mb-2 md:mb-0 md:py-0">The Platform</a>
                <router-link to="/resources" class="router-link border-solid border-b border-green-100 md:border-0 py-3 mb-2 md:mb-0 md:py-0">Resources</router-link>
                <a href="https://www.marker-ai.com/contact-us" class="router-link py-3 mb-2 md:mb-0 md:py-0">Contact</a>

            </div>

            

            <!-- <router-view></router-view> -->
            
        </div>

        <div class="flex flex-col md:flex-row justify-between gap-2">

            <div>
                <p class="font-sans text-white text-sm md:text-md">© Copyright Marker 2025 <span class="px-4">|</span> All rights reserved.</p>
            </div>
            <div>
                <p class="font-sans text-white text-sm md:text-md"><a href="https://www.marker-ai.com/privacy">Privacy</a> <span class="px-4">|</span> <a href="https://www.marker-ai.co.uk/downloads/marker-terms-and-conditions.pdf" target="_blank">Terms and Conditions</a></p>
            </div>

        </div>
    </section>
    
    
      
  </template>

